/**
 * SimulatorCard — Escalation Simulator configuration + results display.
 *
 * Renders Event Category select, Duration number input, Time of Day time input
 * in a 3-column grid, plus a scrollable simulation results table.
 *
 * All state is owned by the parent DemoPage — this component receives
 * everything via props and calls onChange handlers for updates.
 */

import { convertIsoToLocalTime } from '../../../libs.jsx';

const SimulatorCard = ({
    eventCatData,
    eventCatId,
    onEventCatChange,
    duration,
    onDurationChange,
    timeOfDay,
    onTimeOfDayChange,
    simulateData,
    loadingSimulate,
}) => {
    return (
        <div className="dm-card">
            <h3 className="dm-card__header">Escalation Simulator</h3>
            <div className="dm-card__body">
                {/* Config inputs — 3-column grid */}
                <div className="dm-sim-config">
                    <div>
                        <label htmlFor="dm-event-cat" className="dm-field__label">Event Category</label>
                        <select
                            id="dm-event-cat"
                            className="dm-field__select"
                            value={eventCatId}
                            onChange={(e) => onEventCatChange(parseInt(e.target.value, 10))}
                        >
                            {(eventCatData || []).map((cat) => (
                                <option key={cat.event_category_id} value={cat.event_category_id}>
                                    {cat.event_category_name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label htmlFor="dm-sim-duration" className="dm-field__label">Duration (Min)</label>
                        <input
                            type="number"
                            id="dm-sim-duration"
                            className="dm-field__input"
                            value={duration}
                            min={1}
                            max={60}
                            step={1}
                            onChange={(e) => onDurationChange(parseInt(e.target.value, 10) || 30)}
                        />
                    </div>
                    <div>
                        <label htmlFor="dm-sim-time" className="dm-field__label">Time of Day</label>
                        <input
                            type="time"
                            id="dm-sim-time"
                            className="dm-field__input"
                            value={timeOfDay}
                            onChange={(e) => onTimeOfDayChange(e.target.value)}
                        />
                    </div>
                </div>

                {/* Results table */}
                <div className="dm-sim-results">
                    {loadingSimulate ? (
                        <div className="dm-sim-empty">
                            <span className="dm-spinner" />Simulating...
                        </div>
                    ) : simulateData.length === 0 ? (
                        <div className="dm-sim-empty">
                            Select a device and click "Simulate Careflow" to run
                        </div>
                    ) : (
                        <table className="dm-sim-table">
                            <thead>
                                <tr>
                                    <th>Event Time</th>
                                    <th>Event Action</th>
                                    <th>To</th>
                                </tr>
                            </thead>
                            <tbody>
                                {simulateData.map((row, idx) => (
                                    <tr key={idx}>
                                        <td style={{ minWidth: 100 }}>{convertIsoToLocalTime(row.timestamp)}</td>
                                        <td style={{ minWidth: 175 }}>{row.handler}</td>
                                        <td style={{ minWidth: 100 }}>
                                            {Array.isArray(row.to)
                                                ? row.to.map((item, i) => (
                                                    <span key={i}>{i > 0 ? <br /> : null}{item}</span>
                                                ))
                                                : row.to
                                            }
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SimulatorCard;
